import { render, staticRenderFns } from "./CarouselTeamInfo.vue?vue&type=template&id=35d4c8f5&scoped=true&"
import script from "./CarouselTeamInfo.vue?vue&type=script&lang=js&"
export * from "./CarouselTeamInfo.vue?vue&type=script&lang=js&"
import style0 from "./CarouselTeamInfo.vue?vue&type=style&index=0&id=35d4c8f5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d4c8f5",
  null
  
)

export default component.exports